/**
 * Bouton charte Factures (primary / ghost / danger) — suit le thème.
 */
import type { ButtonHTMLAttributes, ReactNode } from "react";

const variants = {
  primary: "fx-btn-primary text-white hover:opacity-95 disabled:opacity-45",
  ghost: "fx-btn-ghost disabled:opacity-45",
  danger: "fx-btn-danger disabled:opacity-45",
} as const;

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: keyof typeof variants;
  children: ReactNode;
};

export function Button({ variant = "primary", className = "", type = "button", children, ...rest }: ButtonProps) {
  return (
    <button
      type={type}
      className={`cursor-pointer rounded-lg px-3.5 py-2 text-sm ${variants[variant]} ${className}`}
      {...rest}
    >
      {children}
    </button>
  );
}
